const PageSubtitle = ({ children }) => {
  return <h3 className={'comp-page-subtitle'}>{children}</h3>;
};

export default PageSubtitle;
